import CareMapprButton from '../../components/Button/CareMapprButton';
import LegalTenancySelection from './LegalTenancySelection';
import { useLegalContent, type LegalContentGroup } from './LegalContentContext';

type Props = {
  isTermsActive: boolean;
  contentGroup: LegalContentGroup;
};

const LegalTenancyPage = ({ isTermsActive, contentGroup }: Props) => {
  const { getContent, selectedTenancyKey, setSelectedTenancyKey } =
    useLegalContent();

  if (!selectedTenancyKey) {
    return (
      <LegalTenancySelection
        isTermsActive={isTermsActive}
        onSelect={(tenancyKey) => {
          setSelectedTenancyKey(tenancyKey);
        }}
      />
    );
  }

  return (
    <div className="d-flex flex-column align-items-start">
      <CareMapprButton
        extraClassNames="min-width-0 ps-0"
        variant="link"
        onClick={() => setSelectedTenancyKey(null)}
        label="Back"
      />
      {getContent(contentGroup, selectedTenancyKey)}
    </div>
  );
};

export default LegalTenancyPage;
